import React from "react";
import { cn } from "../../utils/cn";

interface FormActionsProps {
  children: React.ReactNode;
  className?: string;
}

const FormActions: React.FC<FormActionsProps> = ({ children, className }) => (
  <div
    className={cn(
      "flex w-full gap-3 md:justify-end md:gap-4 [&>*]:flex-1 md:[&>*]:flex-none",
      className,
    )}
  >
    {children}
  </div>
);

export default FormActions;
